export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-9.83aa5222.jpg";